import { ApiKeyDisplay } from '../components/ApiKeyDisplay';
import { PlanBadge } from '../components/PlanBadge';
import type { License } from '../api/portalApi';
import styles from './Licenses.module.css';

interface LicensesProps {
  licenses: License[];
}

export function Licenses({ licenses }: LicensesProps) {
  return (
    <div>
      <h1 className={styles.title}>Your Licenses</h1>

      {licenses.length === 0 ? (
        <div className={styles.empty}>
          <p>No licenses found.</p>
        </div>
      ) : (
        <div className={styles.list}>
          {licenses.map((lic) => {
            const isExpired = new Date(lic.expiresAt) <= new Date();
            const statusClass = !lic.isActive
              ? styles.statusRevoked
              : isExpired
                ? styles.statusExpired
                : styles.statusActive;
            const statusLabel = !lic.isActive ? 'Revoked' : isExpired ? 'Expired' : 'Active';

            return (
              <div key={lic.apiKey} className={styles.card}>
                <div className={styles.cardHeader}>
                  <div>
                    <span className={styles.pluginName}>{lic.plugins.join(', ')}</span>
                    <span className={`${styles.statusDot} ${statusClass}`}>{statusLabel}</span>
                  </div>
                  <PlanBadge plan={lic.plan} />
                </div>

                <ApiKeyDisplay apiKey={lic.apiKey} />

                <div className={styles.meta}>
                  <div className={styles.metaItem}>
                    <span className={styles.metaLabel}>Expires</span>
                    <span>{lic.expiresAt === '9999-12-31T23:59:59.999Z' ? 'Never' : new Date(lic.expiresAt).toLocaleDateString()}</span>
                  </div>
                  <div className={styles.metaItem}>
                    <span className={styles.metaLabel}>Domains</span>
                    <span>
                      {lic.domains.length > 0 ? lic.domains.join(', ') : 'None yet'}
                      {lic.maxDomains > 0 ? ` (${lic.domains.length}/${lic.maxDomains})` : ' (unlimited)'}
                    </span>
                  </div>
                  <div className={styles.metaItem}>
                    <span className={styles.metaLabel}>Site ID</span>
                    <span className={styles.mono}>{lic.siteId}</span>
                  </div>
                  <div className={styles.metaItem}>
                    <span className={styles.metaLabel}>Created</span>
                    <span>{new Date(lic.createdAt).toLocaleDateString()}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
